import React, { Fragment, useState } from "react";
import { useFormikContext } from "formik";
import get from "lodash/get";
import Overlay from "components/Overlay";
import CommonCheckoutBuilder from "../CommonCheckoutBuilder";
import CommonCheckoutSummary from "components/CommonCheckoutSummary";
import { STATE_KEYS } from "utils/constants/state";

const CHECKOUT_PICKER_INTENT = {
  SELECT_COMMON: "SELECT_COMMON"
};

const CommonCheckoutConfig = ({ name }) => {
  const { touched, setFieldValue, setFieldTouched } = useFormikContext();
  const checkoutCommonPath = `${name}.${STATE_KEYS.PRODUCT_COLLECTION.CONFIG_CHECKOUT_COMMON}`;
  const [intent, setIntent] = useState(null);

  let overlayContent;
  const showOverlay = Boolean(intent);
  if (intent === CHECKOUT_PICKER_INTENT.SELECT_COMMON) {
    overlayContent = (
      <CommonCheckoutBuilder
        name={name}
        hideBuilder={() => setIntent(null)}
        goBack={(commonConfig) => {
          setFieldValue(checkoutCommonPath, commonConfig);
          const isTouched = get(touched, checkoutCommonPath);
          if (!isTouched) {
            setFieldTouched(checkoutCommonPath, true);
          }
          setIntent(null);
        }}
      />
    );
  }

  const showMenu = () => setIntent(CHECKOUT_PICKER_INTENT.SELECT_COMMON);

  return (
    <Fragment>
      <CommonCheckoutSummary name={name} showMenu={showMenu} />
      {showOverlay && overlayContent && (
        <Overlay hideOverlay={() => setIntent(null)}>{overlayContent}</Overlay>
      )}
    </Fragment>
  );
};

export default CommonCheckoutConfig;
